module.exports = __webpack_public_path__ + "img/05-1新闻资讯.149a18a7.png";